// extracted by mini-css-extract-plugin
export default {"vimeoEmbedContainer":"YkPIc","vimeoMargins":"y338F"};